var scope_0 = require('D:/MapshareSite-MSA-EMIS-v3/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7daacf4da923141f4468a37b67dc5852.js').default;export default
        Object.assign({}, scope_0 )
    